import React, { useState, useEffect, useCallback } from 'react';
import { changeTimezone } from 'utils/api';
import { toast } from 'react-toastify';
import { Input, CustomInput } from 'reactstrap';
import Toggle from 'react-toggle';
import {changeSocialMediaSettings} from 'utils/api/settingsApi';
import {throttle} from 'lodash';
import 'react-toggle/style.css';
import Loader from 'components/Loader';

const defaultTimezones = [
    'America/Chicago',
    'America/Los_Angeles',
    'America/New_York',
    'America/Phoenix',
    'Asia/Dubai',
    'Asia/Shanghai',
    'Asia/Tokyo',
    'Australia/Sydney',
    'Europe/London',
    'Europe/Paris',
]

const AlertSettings = (props) => {
    const {profile, refreshProfile} = props;
    const [loading, setLoading] = useState(true);
    const [userDetectedTimezone, setUserDetectedTimezone] = useState(null);
    const [selectedTimezone, setSelectedTimezone] = useState(null);
    const [timezoneLoading, setTimezoneLoading] = useState(true);
    const [socialMediaChecked, setSocialMediaChecked] = useState(false);
    const [submitting, setSubmitting] = useState(false);

    useEffect(() => {
        getTimezones();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if(!profile) return;
        if(profile.account && profile.account.timezone !== selectedTimezone) {
            setSelectedTimezone(profile.account.timezone);
            timezoneLoading && setTimezoneLoading(false);
        }
        profile.hasOwnProperty('isSocialEmailLink') && setSocialMediaChecked(profile.isSocialEmailLink);
        setLoading(false);
    }, [profile])
    
    const getTimezones =  async () => {
        setTimezoneLoading(true);
        try {
            profile.account && setSelectedTimezone(profile.account.timezone);
            setTimezoneLoading(false);
        } catch (err) {
            toast.error(err);
            setTimezoneLoading(false);
        }
    }

    const handleTimezoneChange = async (timezoneString) => {
        setTimezoneLoading(true);
        try {
            let params = {
                timezone: timezoneString ? timezoneString : null
            }
            await changeTimezone(params)
            refreshProfile();
            toast.success('Timezone successfully changed');
            setSelectedTimezone(timezoneString);
            setTimezoneLoading(false);
        } catch (err) {
            toast.error('An error occurred while changing the timezone');
            console.log(err)
            setTimezoneLoading(false);
        }
    }

    const handleSocialMediaSettingsChange = async() => {
        if(submitting) return;
        try {
            setSubmitting(true);
            setSocialMediaChecked(prevState => !prevState)
            await changeSocialMediaSettings()
            refreshProfile();
            setSubmitting(false)
        } catch(err) {
            console.log(err);
            setSubmitting(false);
        }
    }

    const throttledChangeHandler = useCallback(
        throttle(handleSocialMediaSettingsChange, 700)
        , []);

    if(loading) return <div className="mt-4"><Loader small/></div>
    return (
        <div className="account-card">
            <div className="d-flex mt-2 w-100 justify-content-between align-items-center" style={{height: '35px'}}>
                <h4>Timezone</h4>
                {timezoneLoading
                    ? (
                        <div style={{ display: 'flex', justifyContent: 'center', width: '200px', padding: '10px 5px'}}>
                            {/*<i className="fa fa-spinner fa-spin" />*/}
                            <Loader small/>
                        </div>
                    ) : (
                        <div style={{ display: 'flex', justifyContent: 'center', width: '200px' }}>
                            <Input
                                value={selectedTimezone}
                                onChange={(e) => handleTimezoneChange(e.target.value)} 
                                type="select"
                            >
                                {userDetectedTimezone && !defaultTimezones.includes(userDetectedTimezone) && 
                                    <option value={userDetectedTimezone}>{userDetectedTimezone}</option>
                                }
                                {defaultTimezones.map(timezone => 
                                    <option key={timezone} value={timezone}>{timezone}</option>
                                )}
                            </Input>
                        </div>
                    )
                }
            </div>
            <div style={{ marginTop: '.5rem', width: '100%'}}>
                <h4 className="mb-1">Daily Digest Schedule</h4>
                <p style={{ fontSize: '12px', marginBottom: '10px' }}>Delivered at 9:00 AM in your local time zone</p>
                <div className="daily_digest-checkboxes">
                    <CustomInput
                        id="daily-mon"
                        inline 
                        disabled
                        type="checkbox" 
                        label="Mon" 
                        checked={true} 
                    />
                    <CustomInput
                        id="daily-tue"
                        inline 
                        disabled
                        type="checkbox" 
                        label="Tue" 
                        checked={true} 
                    />
                    <CustomInput
                        id="daily-wed"
                        inline 
                        disabled
                        type="checkbox" 
                        label="Wed" 
                        checked={true} 
                    />
                    <CustomInput
                        id="daily-thu"
                        inline 
                        disabled
                        type="checkbox" 
                        label="Thu" 
                        checked={true} 
                    />
                    <CustomInput
                        id="daily-fri"
                        inline 
                        disabled
                        type="checkbox" 
                        label="Fri" 
                        checked={true} 
                    />
                    <CustomInput
                        id="daily-sat"
                        inline 
                        disabled
                        type="checkbox" 
                        label="Sat" 
                        checked={true}
                    />
                    <CustomInput
                        id="daily-sun"
                        inline 
                        disabled
                        type="checkbox" 
                        label="Sun" 
                        checked={true}
                    />
                </div>
            </div>
            <div style={{ marginTop: '4rem', width: '100%', marginBottom: '3.5rem'}}>
                <h4 className="mb-1">Continuous Alerts Schedule</h4>
                <p style={{ fontSize: '12px', marginBottom: '10px' }}>Delivered continuously around the clock</p>
                <div className="daily_digest-checkboxes">
                    <CustomInput
                        id="real-mon"
                        inline 
                        disabled
                        type="checkbox" 
                        label="Mon" 
                        checked={true} 
                    />
                    <CustomInput
                        id="real-tue"
                        inline 
                        disabled
                        type="checkbox" 
                        label="Tue" 
                        checked={true} 
                    />
                    <CustomInput
                        id="real-wed"
                        inline 
                        disabled
                        type="checkbox"
                        label="Wed" 
                        checked={true} 
                    />
                    <CustomInput
                        id="real-thu"
                        inline 
                        disabled
                        type="checkbox"
                        label="Thu" 
                        checked={true} 
                    />
                    <CustomInput
                        id="real-fri"
                        inline 
                        disabled
                        type="checkbox" 
                        label="Fri" 
                        checked={true} 
                    />
                    <CustomInput
                        id="real-sat"
                        inline 
                        disabled
                        type="checkbox" 
                        label="Sat" 
                        checked={true}
                    />
                    <CustomInput
                        id="real-sun"
                        inline 
                        disabled
                        type="checkbox" 
                        label="Sun" 
                        checked={true}
                    />
                </div>
            </div>
            <div className="social-media-settings-toggle">
                <label>
                    <Toggle
                        checked={socialMediaChecked}
                        icons={false}
                        onChange={() => !submitting && throttledChangeHandler()}
                    />
                </label>
                <span className="toggle" id="toggle">Read Social Media content locally</span>&nbsp;&nbsp;
                {submitting && <Loader small/>}
            </div>
        </div>
    );
}

export default AlertSettings;
